import styled from '@emotion/styled';
import { theme } from '../component-library';
import Icon from '../component-library/src/components/Icon';
import { useMediaQuery } from '../helpers/useMediaQuery';
import { Flex } from '../2022-component-library';

const StyledTable = styled.table`
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  overflow: hidden;
  width: 100%;
  thead {
    background: rgba(0, 0, 0, 0.05);
    th {
      border: thin solid ${theme.colors.grey};
      padding: 8px;
      color: #000;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }
  }
  tbody {
    tr {
      &:last-of-type {
        border-bottom: 0px;
      }
      td {
        border: thin solid ${theme.colors.grey};
        text-align: center;
        padding: 8px;
        color: #000;
        font-size: 14px;
        svg {
          &:hover {
            cursor: pointer;
          }
        }
        &.name {
          min-width: 150px;
        }
      }
    }
  }
`;

const Table = ({ data, handleSelectedTest, deleteTest }) => {
  const smallScreen = useMediaQuery('(max-width: 750px)');
  return (
    <Flex width='100%' maxHeight={smallScreen ? '60%' : '70%'} overflow='auto'>
      <StyledTable>
        <thead>
          <tr>
            <th className='name'>{'Test Name'}</th>
            <th>{'Date'}</th>
            <th>{`View ${!smallScreen ? 'Results' : ''}`}</th>
            <th>{`Delete ${!smallScreen ? 'Results' : ''}`}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((test) => {
            return (
              <tr key={`completed-test-${test.id}`}>
                <td className='name'>
                  <span>{test.test_title}</span>
                </td>
                <td>{test.submission_date}</td>
                <td>
                  <Icon onClick={() => handleSelectedTest(test)} icon='arrow-right2' color={theme.colors.primary} size={20} />
                </td>
                <td>
                  <Icon onClick={() => deleteTest(test.id)} icon='bin2' color={theme.colors.negativeDark} size={20} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </StyledTable>
    </Flex>
  );
};

export default Table;
